/* ============================================================
   Cart Icon animation — native port of the Visually experiment
   "M+D - SW - Animate Cart Icon". Shakes the header cart icon
   whenever the cart-count bubble value changes. Halo/ripple styling
   lives in assets/cart-icon-animate.css.
   ============================================================ */
(function () {
  if (window.__heavysCartIconAnimate) return;
  window.__heavysCartIconAnimate = true;

  function bubbleText(icon) {
    var span = icon.querySelector('.cart-count-bubble span[aria-hidden]');
    return (span && span.textContent ? span.textContent.trim() : '') || '';
  }

  function init() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return false;
    if (icon.__heavysShakeBound) return true;
    icon.__heavysShakeBound = true;

    var lastCount = bubbleText(icon);

    var shake = function () {
      icon.style.animation = 'none';
      void icon.offsetWidth; // reflow to restart the animation
      icon.style.animation = 'heavys-cart-shake 0.5s ease';
    };

    var observer = new MutationObserver(function () {
      var current = bubbleText(icon);
      if (current && current !== lastCount) shake();
      lastCount = current;
    });

    observer.observe(icon, { childList: true, subtree: true, characterData: true });
    icon.addEventListener('animationend', function () {
      icon.style.animation = '';
    });
    return true;
  }

  if (!init()) {
    // The header can render/replace the cart icon late (drawer, section
    // rendering API). Retry briefly until it exists.
    var tries = 0;
    var timer = setInterval(function () {
      if (init() || ++tries >= 40) clearInterval(timer);
    }, 250);
  }

  // Re-bind after Shopify section re-renders (theme editor / cart updates).
  document.addEventListener('shopify:section:load', init);
})();
